import { Colors } from '../consts/Colors';

export default class CircularAudioPlayer extends Phaser.GameObjects.Container {
    constructor(scene, x, y, audioKey, radius = 93, stroke = 20) {
        super(scene, x, y);
        this.scene = scene;
        this.audioKey = audioKey;
        this.radius = radius;
        this.stroke = stroke;
        this.isPlaying = false;

        // === Circle base ===
        const baseCircle = scene.add.graphics();
        baseCircle.lineStyle(stroke, Colors.Elmt.Blue, 1)
        baseCircle.strokeCircle(0, 0, radius);
        this.add(baseCircle);

        // === Progress arc (maskable)
        this.progressCircle = scene.add.graphics();
        this.add(this.progressCircle);

        // === Icons
        this.iconPlay = scene.add.image(0, 0, 'audioPlay').setOrigin(0.5).setScale(1);
        this.iconPlay.setInteractive({ cursor: 'pointer' });
        this.iconPlay.on('pointerdown', () => this.toggleAudio());
        this.add(this.iconPlay);

        // === Interaction
        this.setSize(radius * 2, radius * 2);

        // === Load sound
        this.sound = scene.sound.add(audioKey, { volume: 1 });

        this.sound.on('complete', () => this.resetPlayer());
        scene.add.existing(this);
    }

    toggleAudio() {
        if (this.isPlaying) {
            this.sound.pause();
            this.iconPlay.setTexture('audioPlay');
            this.isPlaying = false;
            console.log('🔇 Paused');
            this.scene.game.data.currentImage = ''; 

        } else {
            if (!this.sound.isPlaying && this.sound.seek === 0) {
                // console.log('▶️ Starting sound from beginning');
                this.sound.play();
            } else {
                // console.log('▶️ Resuming sound');
                this.sound.resume();
            }

            this.iconPlay.setTexture('audioWave');
            this.isPlaying = true;
        }
    }

    resetPlayer() {
        this.isPlaying = false;
        this.iconPlay.setTexture('audioPlay');
        this.sound.stop(); // facultatif mais nettoie bien
        this.sound.seek = 0; // remet à 0 si tu veux forcer une nouvelle lecture
        this.drawProgressArc(0); // remet la barre à zéro visuellement
    }

    update() {
        if (this.isPlaying && this.sound.isPlaying) {
            const progress = this.sound.seek / this.sound.duration;
            this.drawProgressArc(progress);
        }
    }

    drawProgressArc(progress) {
        const g = this.progressCircle;
        g.clear();
        g.lineStyle(this.stroke, 0xffffff, 1); // Blanc
        g.beginPath();
        g.arc(0, 0, this.radius, -Math.PI / 2, -Math.PI / 2 + progress * Math.PI * 2, false);
        g.strokePath();
    }
}
